import React, { useMemo, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { FieldRenderProps } from 'react-final-form'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import styles from '../../styles'
import IntlTelInput, { CountryData } from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/main.css'
import { countryPhoneList } from './enum/countryEnum'
import languagesEnum from '../../enums/languagesEnum'
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles(
	(theme) => (
		{
			...styles(theme),
			textFieldStyle: {
				display: 'flex',
				flexDirection: 'column',
				padding: '8px 8px 8px 0px',

				'& input': {
					...styles(theme).text1,
					fontSize: 20,
					fontWeight: 500,
					opacity: 0.7,
					lineHeight: 1.33,
					border: 'none',
					borderBottom: '2px solid #d0d4d9',
					paddingTop: 7
				}
			},
			errorStyle: {
				color: '#B92D00',
				fontSize: '10px'
			},
			errorColor: {
				color: '#B92D00 !important'
			},
			errorBorder: {
				border: '1px solid #B92D00'
			},
			disabledStyle: {
				'& input': {
					opacity: '0.7 !important'
				},
				'& .MuiInput-underline:before': {
					borderBottom: '0'
				}
			},
			textFieldLargeScreenStyle: {
				'& input': {
					fontSize: 20,
					fontWeight: 500,
					color: theme.palette.blue.main
				}
			},
			textFieldSmallScreenStyle: {
				'& input': {
					fontSize: 16,
					fontWeight: 500,
					color: theme.palette.blue.main
				}
			},
		}
	)
)

interface AcceptingProps {
	label?: string,
	disabled?: boolean
}

type FormTextFieldDossierProps =
	FieldRenderProps<string>
	& AcceptingProps

const FormPhoneField: React.FC<FormTextFieldDossierProps> = (
	{
		input,
		meta: {
			touched,
			error,
			submitError
		},
		label,
		disabled,
	}
) => {
	const classes = useStyles()
	const inputRef = useRef(null)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const labelClass: ClassValue = classNames(
		classes.text8,
		{
			[classes.errorColor]: touched && (error || submitError)
		}
	)
	const getCountryByPhone = useMemo(() => {
		if (!input.value || input.value.length === 0 || !input.value.includes('+')) {
			return languagesEnum.fr
		}

		const countryFiltered = countryPhoneList.filter((countryPhone) => countryPhone[2] === input.value.split('+')[1].split(' ')[0])

		if (countryFiltered.length > 0) {
			return countryFiltered[0][1] as string
		}

		return languagesEnum.fr
	}, [input.value])

	const textFieldClass: ClassValue = classNames(
		'intl-tel-input',
		classes.textFieldStyle,
		{
			[classes.textFieldLargeScreenStyle]: isLargeScreen,
			[classes.textFieldSmallScreenStyle]: !isLargeScreen,
			[classes.errorBorder]: touched && error,
			[classes.disabledStyle]: disabled
		}
	)

	const onChange = (isValid: boolean, value: string, selectedCountryData: CountryData, fullNumber: string, extension: string) => {
		input.onChange(fullNumber)
	}

	return (
		<div>
			<span
				className={labelClass}
			>
				{label}
			</span>

			<IntlTelInput
				ref={inputRef}
				preferredCountries={[getCountryByPhone]}
				onPhoneNumberChange={onChange}
				containerClassName={textFieldClass}
				defaultValue={input.value}
			/>

			{(error || submitError) && touched && (
				<span className={classes.errorStyle}>{error || submitError}</span>
			)}
		</div>
	)
}

export default FormPhoneField
